<template>

  <Header />

  <SearchOrders />

  <div class="section container section--lg">
    <div class="content">
      <div class="heading d-flex justify-content-between align-items-center">
        <h1 v-if="fullView">Orders</h1>
        <h1 v-if="!fullView">Draft Orders</h1>
        <div class="d-flex align-items-center switch-group">
          <input class="switch" type="checkbox" id="switch" @change="fullView = !fullView" />
          <label for="switch"></label>
        </div>
      </div>
      <table class="table" :class="fullView ? 'table-fullview' : 'table-draft-only'">
        <thead>
          <tr>
            <th>Order #</th>
            <th>Name</th>
            <th>Status</th>
            <th>Tracking</th>
            <th>Order Date</th>
          </tr>
        </thead>
        <tr v-if="isLoading"><td colspan="5"><div class="loading-spinner"/></td></tr>
        <tbody v-if="isLoading == false && orders.length > 0">
          <tr v-for="order in orders" :key="order.id" :class="order.status">
            <td width="85px"><a href="/" class="col-num-order" @click.prevent="viewOrderDetails(order.order_number)">{{ order.order_number }}</a></td>
            <td><a class="col-name" href="/" @click.prevent="viewOrderDetails(order.order_number)">{{ order.customer.first_name }} {{ order.customer.last_name }}</a></td>
            <td>
              <div class="col-status">
                <a class="col__status" @click.prevent="viewOrderDetails(order.order_number)" href="/" :class="`col__status--${order.status}`">{{ (order.status.charAt(0).toUpperCase() + order.status.slice(1)).replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) }}</a>
              </div>
            </td>
            <td>
              <a class="col-tracking" v-if="order.tracking_details.length && order.tracking_details[0].url" :href="order.tracking_details[0].url" target="_blank">LINK</a>
              <span v-else>N/A</span>
            </td>
            <td>
              <div class="col-status">
                <div v-if="order.status === 'draft' || order.status === 'expired' || order.status === 'canceled'">
                  <span v-if="order.status === 'draft'">DRAFT</span>
                  <span v-if="order.status === 'expired'">EXP</span>
                  <span v-if="order.status === 'canceled'">CXL</span>
                </div>
                <span v-else>{{ helpers.formatDate(order.created_at) }}</span>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="orders.length === 0 && requestCompleted">
          <tr><td colspan="3"><div class="col-no-results">No orders yet!</div></td></tr>
        </tbody>
      </table>
      <div v-if="showPagination && fullView" class="pagination-container">
        <div class="pagination-pages">
          <b-pagination v-if="totalRecords > 0"
            v-model="currentPage"
            @change="fetchOrders($event)"
            :total-rows="totalRecords"
            :per-page="20"
            hide-goto-end-buttons="true"
            next-class="pagination-next"
            prev-class="pagination-prev"
          ></b-pagination>
        </div>
        <div class="pagination-view-all"><span @click="fetchAllOrders">VIEW ALL</span></div>
      </div>
    </div>
  </div>

</template>

<script>
import Header from '../components/Header.vue';
import SearchOrders from '../components/SearchOrders.vue';

export default {
  name: 'Home',
  components: {
    Header, SearchOrders
  },
  data() {
    return {
      orders: [],
      fullView: true,
      requestCompleted: false,
      isLoading: true,
      totalPages: 1,
      currentPage: 1,
      nextPageInfo: null,
      previousPageInfo: null,
      totalRecords: 0,
      showPagination: false,
    }
  },
  methods: {
    viewOrderDetails(orderId) {
      this.$router.push(`/order/${orderId}`);
    },
    fetchOrders(page) {
      if(this.currentPage == page) {
        var path = `/v1/orders.json?next_page_info&limit=20&paginated=${true}&page=1`;
      } else if(page > this.currentPage) {
        path = `/v1/orders.json?next_page_info=${this.nextPageInfo}&page=${page}&limit=20&paginated=${true}`
      } else {
        path =`/v1/orders.json?previous_page_info=${this.previousPageInfo}&page=${page}&limit=20&paginated=${true}`;
      }
      this.currentPage = page
      this.isLoading = true;
      this.axios.get(path)
      .then(response => {
        if(typeof response.data.records !== 'undefined') {
          this.totalRecords = response.data.total
          this.currentPage = response.data.page
          this.totalPages = response.data.pages
          this.nextPageInfo = response.data.next_page_info
          this.previousPageInfo = response.data.previous_page_info
          this.orders = response.data.records
          this.showPagination = true
          this.isLoading = false;
          this.orders.map(function(o) {
            if(o.financial_status == 'pending') {
              if(o.cancelled_at === null) {
                o.status = 'draft'
              }
            }
          });
        }
        this.requestCompleted = true;
        if (history.state && history.state.forward && /\/order\//.test(history.state.forward)) {
          setTimeout(() => {
            window.scrollTo({ top: history.state.scroll.top })
          }, 100)
        }
      })
     .catch((error) => { console.log(error) });
    },
    fetchAllOrders() {
      this.isLoading = true;
      this.showPagination = false
      this.axios.get(`/v1/orders.json`)
      .then(response => {
        if(typeof response.data.records !== 'undefined') {
          this.orders = response.data.records
          this.isLoading = false;
          this.orders.map(function(o) {
            if(o.financial_status == 'pending') {
              if(o.cancelled_at === null) {
                o.status = 'draft'
              }
            }
          });
        }
        this.requestCompleted = true;
        if (history.state && history.state.forward && /\/order\//.test(history.state.forward)) {
          setTimeout(() => {
            window.scrollTo({ top: history.state.scroll.top })
          }, 100)
        }
      })
      .catch((error) => {
        console.log(error)
        this.isLoading = false;
        this.showPagination = true
      });
    }
  },
  mounted() {
    document.body.classList.remove('menu-open');
    this.fetchOrders(1)
  }
}
</script>
<style>
  .col__status--shipped {
    color: #D4B721;
  }

  .col__status--delivered {
    color: #089E56;
  }

  .col__status--draft {
  color: #D43F21;
}

  .col__status--expired {
    color: #C4C4C4;
  }

  .loading-spinner {
    background: url(../assets/images/loading_spinner.gif) no-repeat center center;
    width: 400px;
    height: 400px;
    margin: auto;
  }
</style>
